var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.video && !_vm.loading)?_c('div',[_c('watch-video',{attrs:{"video":_vm.video}})],1):_vm._e(),(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('b-spinner'),_c('br'),_vm._v("Loading Videos"),_c('br'),_c('br')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }